import { ChangeAlertCallbackType } from "../components/Root";
import { getPosition } from "./PositionService";
import * as API from '../http/api';

export class CustomerService {
    private changeAlert: ChangeAlertCallbackType
    constructor(changeAlert: ChangeAlertCallbackType) {
        this.changeAlert = changeAlert
    }

    async customerSearch(data) {
        const pos = getPosition();
        const response = await API.service('free', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async customerCancel(data) {
        const pos = getPosition();
        const response = await API.service('customerCancel', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async customerBlockUnblock(data) {
        const pos = getPosition();
        const response = await API.service('customerBlockUnblock', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async customerVipList(data) {
        const pos = getPosition();
        const response = await API.service('customerVipList', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async customerVipAdd(data) {
        const pos = getPosition();
        const response = await API.service('customerVipAdd', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async customerVipGet(data) {
        const pos = getPosition();
        const response = await API.service('customerVipGet', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async customerVipFind(data) {
        const pos = getPosition();
        const response = await API.service('customerVipFind', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async customerVipUpdate(data) {
        const pos = getPosition();
        const response = await API.service('customerVipUpdate', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async customerSegmentUpdate(data) {
        const pos = getPosition();
        const response = await API.service('customerSegmentUpdate', data, pos, this.changeAlert, null, null);

        return response?.data
    }
    async customerHistoryLogin(data) {
        const pos = getPosition();
        const response = await API.service('customerHistoryLogin', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async customerHistorySession(data) {
        const pos = getPosition();
        const response = await API.service('customerHistorySession', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async customerHistoryDevice(data) {
        const pos = getPosition();
        const response = await API.service('customerHistoryDevice', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async customerHistoryPassword(data) {
        const pos = getPosition();
        const response = await API.service('customerHistoryPassword', data, pos, this.changeAlert, null, null);

        return response?.data
    }

}